<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-block">
        <div class="row">
          <div class="col-sm-5">
            <h4 class="card-title mb-0">Eventos Recebidos</h4>
            <div class="small text-muted">{{interval}}</div>
          </div>
          <div class="col-sm-7 hidden-sm-down">
            <div role="toolbar" aria-label="Toolbar with button groups" class="btn-toolbar float-right">
              <div data-toggle="buttons" aria-label="First group" class="btn-group mr-1">
                <label class="btn btn-outline-secondary" v-bind:class="{ active: selected == '0' }">
                  <input type="radio" v-model="selected" value="0"> 1 d
                </label>
                <label class="btn btn-outline-secondary" v-bind:class="{ active: selected == '60' }">
                  <input type="radio" v-model="selected" value="60"> 1 h
                </label>
                <label class="btn btn-outline-secondary" v-bind:class="{ active: selected == '30' }">
                  <input type="radio" v-model="selected" value="30"> 30 min
                </label>
                <label class="btn btn-outline-secondary" v-bind:class="{ active: selected == '15' }">
                  <input type="radio" v-model="selected" value="15"> 15 min
                </label>
              </div>
            </div>
          </div>
        </div>
        <div v-if="loaded" style="margin-top:15px">
          <div>
            <chart v-if="loaded" :chart-data="chartData" :chart-labels="dates"></chart>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Chart from './shared/Chart'

export default {
  name: 'dashboard',
  components: {
    Chart
  },
  created () {
    this.requestData()
  },
  data () {
    return {
      loaded: true,
      dates: [],
      events: [],
      chartData: [],
      selected: '60'
    }
  },
  computed: {
    interval: function () {
      var intervalLabel = ''
      switch (this.selected) {
        case '0':
          intervalLabel = 'Diário nos últimos 30 dias'
          break
        case '60':
          intervalLabel = 'A cada hora no dia atual'
          break
        case '30':
          intervalLabel = 'A cada 30 minutos no dia atual'
          break
        case '15':
          intervalLabel = 'A cada 15 minutos no dia atual'
          break
      }

      return intervalLabel
    }
  },
  watch: {
    selected: function(newValue, oldValue) {
      this.requestData()
    }
  },
  methods: {
    resetState () {
      this.loaded = false
      this.chartData = []
    },
    randomColor () {
      var letters = '0123456789ABCDEF'
      var color = '#'
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },
    requestData () {
      this.resetState()
      this.loading = true
      axios.get(process.env.API_URL + 'raw-events?interval=' + this.selected).then(response => {
        var reports = response.data
        if (reports.length > 0) {
          this.dates = reports[0].dates.map((obj) => {
            var format = (this.selected === '0') ? 'DD/MM' : 'HH:mm'
            return this.$options.filters.formatDate(obj, format)
          })

          for (var i = 0; i < reports.length; i++) {
            var obj = reports[i]
            var json = {}
            json['label'] = obj.eventType
            json['yAxesGroup'] = obj.eventType
            json['backgroundColor'] = 'transparent'
            json['borderColor'] = this.randomColor()
            json['borderWidth'] = 2
            json['data'] = obj.quantities
            this.chartData.push(json)
          }
        }
        this.loaded = true
      }).catch(err => {
        console.log(err)
        this.showError('Ops. Ocorreu um erro ao carregar os eventos recebidos.')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Dashboard.vue?f8679b20